'use client';
import { takeCouponReq } from '@/apis/dp/service';
import CouponSvg1 from '@/assets/icons/dp-coupon-1.svg';
import CouponSvg2 from '@/assets/icons/dp-coupon-2.svg';
import CouponApplied from '@/assets/icons/dp-coupon-applied.svg';
import { IntlDialog, IntlPopover } from '@/components/intlMui';
import { dataExpTagConfig } from '@/components/product/const';
import UKToast from '@/components/UKToast';
import { useTranslation } from '@/i18n/client';
import ArrowIcon from '@/images/icon/arrow-default.svg';
import { callAfterLoginByUrl, LoginCallBackType } from '@/lib/jdiClientUtils';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25217';
import cookieUtil from '@/intl-jdi-common-ssr/utils/cookieUtils';
import { useRouter } from 'next/navigation';
import { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import MarketActivity from './marketActivity';
import { CouponStatusType } from '@/apis/dp/floor.interface';
import { formatCurrency } from '@/utils/price';
import { LocalInfoType } from '@/apis/common.types';

const CouponContentDetail = styled.div`
  padding: 8px 16px;
  max-width: 250px;
  font-size: 12px;
  line-height: 16px;
`;

const CouponFrameWrapper = styled.div`
  gap: 8px;
  margin-bottom: 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

const CouponAssetsFloor = styled.div`
  display: flex;
  position: relative;
  flex-wrap: wrap;
  cursor: pointer;
  &:hover {
    .h-title {
      text-decoration: underline;
    }
    .arrow {
      text-decoration: underline;
      color: var(--sys-Text-Primary);
      svg {
        path {
          stroke: var(--sys-Text-Primary);
        }
      }
    }
  }
  .h-title {
    font-size: 16px;
    flex-shrink: 0;
    line-height: 22px;
    font-weight: 500;
    margin-right: 12px;
    color: #cc0c1c;
    margin-left: 4px;
    /* &:hover {
      color: var(--dp-hover-state-color);
      text-decoration: underline;
    } */
  }
  .product-coupon-type-2 {
    position: relative;
    &:before {
      position: absolute;
      content: '';
      width: 4px;
      height: 8px;
      left: -1px;
      top: 5px;
      border: 1px solid rgba(255, 15, 35, 0.6);
      border-width: 1px 1px 1px 0;
      border-radius: 0 4px 4px 0;
      background-color: #fff;
    }
    &:after {
      position: absolute;
      content: '';
      width: 4px;
      height: 8px;
      right: -1px;
      top: 5px;
      border: 1px solid rgba(255, 15, 35, 0.6);
      border-width: 1px 0 1px 1px;
      border-radius: 4px 0 0 4px;
      background-color: #fff;
    }
  }
  .arrow {
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    gap: 2px;
    text-align: right;
    white-space: nowrap;
    color: var(--sys-Text-Secondary);

    svg {
      flex-shrink: 0;
    }
    &-icon {
      transform: rotate(-90deg);
    }
  }
`;
const PromotionAssetsFloorWrapper = styled.div`
  display: flex;
  position: relative;
  cursor: pointer;
  font-size: 16px;
  line-height: 22px;
  .content {
    color: #cc0c1c;
    svg {
      vertical-align: text-bottom;
    }
    .txt {
      font-weight: 500;
      margin-right: 12px;
      margin-left: 4px;
    }
    .end-date {
      margin-right: 8px;
    }
    .arrow {
      /* font-size: 14px; */
      gap: 2px;
      text-align: right;
      color: var(--sys-Text-Secondary);

      svg {
        flex-shrink: 0;
      }
      &-icon {
        transform: rotate(-90deg);
      }
    }
  }
  &:hover {
    .content {
      text-decoration: underline;
    }

    /* .content {
      .txt {
        color: var(--dp-hover-state-color);
      }
      .end-date {
        color: var(--dp-hover-state-color);
      }
    } */
    .arrow {
      color: var(--sys-Text-Primary);
      text-decoration: underline;
      svg {
        path {
          stroke: var(--sys-Text-Primary);
        }
      }
    }
  }
`;
const CouponWrapper = styled.div`
  svg {
    vertical-align: text-bottom;
  }
  .h-title {
    margin-right: 8px;
    color: #cc0c1c;
  }
`;
const CouponDialogWrapper = styled.div`
  .coupon-list {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: space-between;
    max-height: 420px;
    overflow-y: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const CouponCardWrapper = styled.div`
  width: 408px;
  position: relative;
  padding: 12px 12px 12px 16px;
  border: 1px solid rgba(255, 159, 167, 1);
  overflow: hidden;
  border-radius: 6px;
  .bestAndDate {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    gap: 4px;
    flex-wrap: wrap;
    .best {
      font-size: 12px;
      line-height: 20px;
      padding: 0 4px;
      background-color: var(--sys-Surface-SurfaceRed);
      color: var(--sys-color-Primary700);
      border-radius: 4px;
    }
  }
  .section-2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .r {
      .more {
        display: block;
        color: var(--sys-color-Primary700);
        padding: 0 8px;
        min-width: 48px;
        max-width: 120px;
        line-height: 20px;
        border: 1px solid var(--sys-color-Primary700);
        font-size: 12px;
        text-align: center;
        border-radius: 4px;
      }
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    width: 8px;
    height: 100%;
    left: -4px;
    background-color: rgba(255, 159, 167, 1);
  }
  .price-wrapper {
    display: flex;
    color: var(--sys-color-Primary700);
    align-items: end;
    margin-bottom: 4px;
    i {
      font-style: normal;
    }
    .ml4 {
      margin-left: 4px;
    }

    .mr12 {
      margin-right: 12px;
    }
    .price-1 {
      font-size: 24px;
      margin-right: 12px;
      line-height: 24px;
    }
    .price-1-1 {
      font-size: 14px;
      line-height: 14px;
      margin-left: 4px;
    }
    .price-2 {
      font-size: 14px;
      padding: 0;
      line-height: 16px;
    }
  }
  .date {
    padding: 4px;
    color: rgba(201, 146, 39, 1);
    background-color: rgba(255, 248, 234, 1);
    border-radius: 4px;
    font-size: 12px;
  }
  .line {
    border-bottom: 1px dashed rgba(255, 159, 167, 1);
    margin-bottom: 8px;
  }
  .description {
    position: relative;
    line-height: 16px;
    padding-right: 30px;
    height: 16px;
    font-size: 12px;
    color: rgba(136, 139, 148, 1);
    cursor: pointer;
    overflow: hidden;
    &:hover {
      .arrow {
        color: rgba(255, 15, 35, 1);
        path {
          stroke: rgba(255, 15, 35, 1);
        }
      }
    }
    .description-text {
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &.expanded {
      white-space: wrap;
      transition: 0.3s all;
      height: auto;
      .arrow {
        transform: rotate(180deg);
      }
      .description-text {
        white-space: wrap;
      }
    }
    .arrow {
      position: absolute;
      right: 0;
      top: 1px;
      transition: transform 0.3s;
    }
  }
  .more {
    cursor: pointer;
  }
`;
const Coupon = ({
  couponInfo,
}: {
  couponInfo: {
    couponDescIntergation: string;
    discount: string;
  };
}) => {
  const couponRef = useRef<HTMLDivElement | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  // const popoverOpen = Boolean(anchorEl);
  // const { t } = useTranslation();
  // const onPopEnter = () => {
  //   setAnchorEl(couponRef.current);
  // };
  // const onPopLeave = () => {
  //   setAnchorEl(null);
  // };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  return (
    <CouponWrapper>
      <div
        ref={couponRef}
        // aria-owns={popoverOpen ? 'mouse-over-popover' : undefined}
        // aria-haspopup='true'
        // onMouseEnter={onPopEnter}
        // onMouseLeave={onPopLeave}
      >
        <CouponSvg1 />
        {couponInfo?.discount && (
          <span className='h-title'>{couponInfo?.couponDescIntergation}</span>
        )}
        {/* {discount && <div className="coupon-text">{`${currency}${discount || ''} Off`}</div>}  */}
      </div>
      {/* <IntlPopover
        id='mouse-over-popover'
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        disableRestoreFocus
        sx={{
          pointerEvents: 'none',
          '&.MuiPopover-paper': {
            fontSize: '12px',
            lineHeight: '16px',
            padding: '8px',
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {content}
      </IntlPopover> */}
    </CouponWrapper>
  );
};

function genCouponContent(htmlStr: string) {
  return <CouponContentDetail dangerouslySetInnerHTML={{ __html: htmlStr }} />;
}

const CouponCard = ({
  data,
  skuId,
  index,
  currency,
  onClaimNotify,
  shipmentType,
  localeInfo,
}: any) => {
  const {
    discount,
    formattedEndTime,
    quota,
    couponName,
    batchId,
    encryptedKey,
    ruleId,
    beginTime,
    endTime,
  } = data?.['C-P#couponInfo&couponBasic'] || {};
  const { bestDesc, couponId, useType, useTypeDesc } = data?.['C-P#couponInfo&couponCore'] || {};
  const [showExpand, setShowExpand] = useState<boolean>(false);
  const [userTypeState, setUserTypeState] = useState<number>(useType);
  const [userTypeDescState, setUserTypeDescState] = useState<string>(useTypeDesc);
  const [couponResponseData, setCouponResponseData] = useState<any>(null);
  const { t } = useTranslation();
  // `/s-for-addon?type=1&couponId=${couponResponseData?.couponId || couponId}&batchId=${batchId}`

  const useLink = useMemo(() => {
    const searchParams = new URLSearchParams(
      `type=1&couponId=${couponResponseData?.couponId || couponId}&batchId=${batchId}&beginTime=${
        couponResponseData?.beginTime || beginTime
      }&endTime=${couponResponseData?.endTime || endTime}`,
    );
    if (shipmentType) {
      searchParams.set('shipmentType', shipmentType);
    }
    return `/s-for-addon?${searchParams.toString()}`;
  }, [couponResponseData, couponId, batchId, beginTime, endTime, shipmentType]);

  const onTakeCoupon = async (params: { scenario?: number; takeCouponReqList: any[] }) => {
    const res = await takeCouponReq(params);
    if (res.code === '200') {
      UKToast.show({
        icon: 'success',
        content: t('dp.coupon.couponClaimed'),
      });
      onClaimNotify?.();
      setUserTypeState(1);
      setUserTypeDescState(t('coupon.use'));
      setCouponResponseData(res?.data?.[0]?.coupons?.[0] || null);
    } else {
      UKToast.show({
        icon: 'error',
        content: res?.msg,
      });
    }
    cookieUtil.clearSessionStorage('LoginCallBackType.dpCouponTaken');
  };
  const onClaim = async () => {
    const reqParams = {
      scenario: 0,
      takeCouponReqList: [
        {
          ruleId,
          encryptedKey,
        },
      ],
    };
    cookieUtil.setSessionStorage('LoginCallBackType.dpCouponTaken', reqParams);
    callAfterLoginByUrl(() => onTakeCoupon(reqParams), { type: LoginCallBackType.dpCouponTaken });
  };
  return (
    <CouponCardWrapper>
      <div
        className='section-2'
        exptag={'exp|' + EXPOSURE_RECORD.Productdetail_CouponLayer_Coupon_Expo}
        data-exptag-config={dataExpTagConfig}
        data-exptag-json-param={JSON.stringify({
          mainskuid: skuId,
          couponName: couponName,
          couponId: couponId || '',
          batchId: String(batchId),
          index,
        })}
      >
        <div className='l'>
          <div
            className='price-wrapper'
            dangerouslySetInnerHTML={{
              __html: t('coupon.off_over', {
                currency: currency,
                n: formatCurrency(discount, {
                  locale: localeInfo.languageCode,
                  currency: localeInfo.currency,
                  minimumFractionDigits: 0,
                })?.full,
                m: formatCurrency(quota, {
                  locale: localeInfo.languageCode,
                  currency: localeInfo.currency,
                  minimumFractionDigits: 0,
                })?.full,
              }),
            }}
          />
          <div className='bestAndDate'>
            {bestDesc && <span className='best'>{bestDesc}</span>}
            <span className='date'>
              {t('coupon.validUntil', { time: couponResponseData?.endTime || formattedEndTime })}
            </span>
          </div>
        </div>

        <div className='r'>
          {userTypeState === 2 ? (
            <span className='more' onClick={onClaim}>
              {userTypeDescState}
            </span>
          ) : (
            <a href={useLink}>
              <span className='more'>{userTypeDescState}</span>
            </a>
          )}
        </div>
      </div>

      <div className='line'></div>
      <div
        className={`description ${showExpand ? 'expanded' : ''}`}
        onClick={() => setShowExpand(!showExpand)}
      >
        <div className='description-text'>{couponName}</div>
        {couponId && (
          <span>
            {t('coupon.code')}: {couponId}
          </span>
        )}
        <ArrowIcon className='arrow' />
      </div>
    </CouponCardWrapper>
  );
};

const CouponDialogContent = ({
  list = [],
  skuId,
  currency,
  onClaimNotify,
  shipmentType,
  localeInfo,
}: {
  list: any[];
  skuId: string;
  currency: string;
  shipmentType: string;
  onClaimNotify: () => void;
  localeInfo: LocalInfoType;
}) => {
  return (
    <CouponDialogWrapper>
      <div
        className='coupon-list'
        exptag={'exp|' + EXPOSURE_RECORD.Productdetail_CouponLayer_Expo}
        data-exptag-config={dataExpTagConfig}
        data-exptag-json-param={JSON.stringify({ mainskuid: skuId })}
      >
        {list?.map((item: any, index: number) => (
          <CouponCard
            data={item}
            key={index}
            skuId={skuId}
            index={index}
            currency={currency}
            onClaimNotify={onClaimNotify}
            shipmentType={shipmentType}
            localeInfo={localeInfo}
          />
        ))}
      </div>
    </CouponDialogWrapper>
  );
};

const PromotionAssetsFloor = ({
  goPromotionPage,
  promotionDesc,
  skuId,
  promotionId,
  useStatus,
}: any) => {
  const { t } = useTranslation();
  return (
    <PromotionAssetsFloorWrapper
      onClick={() => goPromotionPage(promotionDesc, String(promotionId))}
    >
      <section className='content'>
        <CouponSvg2 />
        <span className='txt'>{promotionDesc}</span>
        {/* <span className="end-date" suppressHydrationWarning>Ends in { (days > 0 ? days+ ' days ': '') + (hour + "").padStart(2, "0")}:{(minute + "").padStart(2, "0")}:{(second + "").padStart(2, "0")}  </span> */}
        <span
          className='arrow'
          exptag={'exp|' + EXPOSURE_RECORD.Productdetail_MarketFloor_Expo}
          data-exptag-config={dataExpTagConfig}
          data-exptag-json-param={JSON.stringify({
            mainskuid: skuId,
            displayText: promotionDesc,
            promotionId: String(promotionId),
          })}
        >
          {/* {t("dp.limitedTime")} */}
          {useStatus && (
            <>
              {/* <CouponApplied /> */}
              {useStatus}
            </>
          )}
          <ArrowIcon className='arrow-icon' />
        </span>
      </section>
    </PromotionAssetsFloorWrapper>
  );
};

export default function SkuCoupon(props: { floors: any; skuId: string; localInfo: LocalInfoType }) {
  const { skuId } = props;
  const { t } = useTranslation();
  const { couponHint, couponDetailPartList } = props.floors?.productAssetsFloor?.data || {};
  const { fulfillmentMethodList } = props.floors?.productCommonFloor?.data?.deliveryInfo || {};
  const shipmentType =
    fulfillmentMethodList?.length === 1 ? fulfillmentMethodList?.[0]?.shipmentType : '';

  const couponFloorData = couponDetailPartList?.slice(0, 1)?.[0];
  const { useStatus: couponUseStatus, guideHit } =
    couponFloorData?.['C-P#couponInfo&couponCore'] || {};
  const couponInfo = couponFloorData?.['C-P#couponInfo&couponBasic'] || {};
  const productAssetsFloor = props.floors?.productAssetsFloor;
  const { promotionPartList, giftsPart, samplePart } = productAssetsFloor?.data || {};
  const {
    formattedEndTime,
    promotionDescIntergation,
    countdown,
    curTimeField,
    promotionId,
    useStatus,
  } = promotionPartList?.[0] || {};
  const router = useRouter();
  const [couponDialogOpen, setCouponDialogOpen] = useState<boolean>(false);
  const localInfo = props.localInfo;
  const [couponClaimed, setCouponClaimed] = useState<boolean>(false);
  const goPromotionPage = (displayText: string, promotionId: string) => {
    sendClickTrack.Productdetail_MarketFloor_Click({
      mainskuid: skuId,
      displayText: displayText,
      promotionId: promotionId,
    });
    const searchParams = new URLSearchParams(`type=0&promotionId=${promotionId}&skuId=${skuId}`);
    if (shipmentType) {
      searchParams.set('shipmentType', shipmentType);
    }

    router.push(`/s-for-addon?${searchParams.toString()}`);
  };

  const clickCouponOpen = (couponName: string, couponId: string) => {
    setCouponDialogOpen(true);
    sendClickTrack.Productdetail_CouponFloor_Click({
      mainskuid: skuId,
      couponName,
      couponId: String(couponId),
    });
  };
  const onInitTakenCoupon = async (params: any) => {
    const res = await takeCouponReq(params);
    if (res.code === '200') {
      UKToast.show({
        icon: 'success',
        content: t('dp.coupon.couponClaimed'),
      });
    } else {
      UKToast.show({
        icon: 'error',
        content: res?.msg,
      });
    }
    cookieUtil.clearSessionStorage('LoginCallBackType.dpCouponTaken');
  };
  const handleCallBackUrl = async () => {
    const url = new URL(window.location.href);
    const isNext = url.searchParams.get('isNext');
    const callbackOptType = url.searchParams.get('callbackOptType');
    if (isNext) {
      if (callbackOptType === LoginCallBackType.dpCouponTaken) {
        url.searchParams.delete('callbackOptType');
        url.searchParams.delete('isNext');
        // 更新url, 不会刷新页面
        window.history.pushState({}, '', url);
        const reqParamsStr = cookieUtil.getSessionStorage('LoginCallBackType.dpCouponTaken');
        if (reqParamsStr) {
          try {
            const params = JSON.parse(reqParamsStr);
            await onInitTakenCoupon(params);
            window.location.reload();
          } catch (err) {}
        }
      }
    }
  };
  useEffect(() => {
    handleCallBackUrl();
  }, []);

  if (!couponDetailPartList?.length && !promotionDescIntergation && !giftsPart && !samplePart) {
    return;
  }

  return (
    <CouponFrameWrapper>
      {giftsPart && <MarketActivity data={giftsPart} mainSkuId={skuId} />}
      {samplePart && <MarketActivity data={samplePart} mainSkuId={skuId} />}

      {/* {活动} */}
      {promotionDescIntergation && (
        <PromotionAssetsFloor
          goPromotionPage={goPromotionPage}
          formattedEndTime={formattedEndTime}
          promotionDesc={promotionDescIntergation}
          countdown={countdown}
          curTimeField={curTimeField}
          promotionId={promotionId}
          skuId={skuId}
          useStatus={useStatus}
        />
      )}
      {/* {优惠券} */}
      {!!couponDetailPartList?.length && (
        <CouponAssetsFloor
          onClick={() =>
            clickCouponOpen(
              couponFloorData?.['C-P#couponInfo&couponBasic']?.couponName,
              couponFloorData?.['C-P#couponInfo&couponCore']?.couponId,
            )
          }
        >
          {/* <Coupon
            // couponHint={couponHint}
            couponInfo={couponInfo}

            // content={couponDesc}
            // content={genCouponContent(`${t('dp.couponValid')} ${
            //   couponFloorData?.['C-P#couponInfo&couponBasic']?.formattedEndTime
            // }<br />
            // ${couponFloorData?.['C-P#couponInfo&couponBasic']?.couponName} <br />
            // ${t('coupon.code')}: ${
            //   couponFloorData?.['C-P#couponInfo&couponCore']?.couponId
            // } <br />`)}
            // currency={localInfo?.currencySymbol}
          /> */}
          <CouponSvg1 />
          {couponInfo?.discount && (
            <span className='h-title'>{couponInfo?.couponDescIntergation}</span>
          )}
          <span
            className='arrow'
            exptag={'exp|' + EXPOSURE_RECORD.Productdetail_CouponFloor_Expo}
            data-exptag-config={dataExpTagConfig}
            data-exptag-json-param={JSON.stringify({
              mainskuid: skuId,
              couponName: couponFloorData?.['C-P#couponInfo&couponBasic']?.couponName,
              batchId: String(couponFloorData?.['C-P#couponInfo&couponCore']?.couponId),
            })}
          >
            {/* {t("dp.bestSavings")} */}
            {couponUseStatus && (
              <>
                {/* {guideHit === CouponStatusType.CouponApply ? <CouponApplied /> : null} */}
                {couponUseStatus}
              </>
            )}
            <ArrowIcon className='arrow-icon' />
          </span>
        </CouponAssetsFloor>
      )}

      <IntlDialog
        title={t('dp.coupons')}
        width={880}
        rootStyles={{
          flexShrink: 0,
        }}
        open={couponDialogOpen}
        content={
          <CouponDialogContent
            list={couponDetailPartList}
            skuId={skuId}
            currency={localInfo?.currencySymbol || ''}
            localeInfo={localInfo}
            onClaimNotify={() => {
              setCouponClaimed(true);
            }}
            shipmentType={shipmentType}
          />
        }
        onClose={() => {
          setCouponDialogOpen(false);
          if (couponClaimed) {
            // router.refresh();
            window.location.reload();
          }
        }}
        showButtonAction={false}
      />
    </CouponFrameWrapper>
  );
}
